import React, { createContext, useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import { get, post, setLogoutCallback, setIsLoggedIn} from "@utils/axios_api";

export const AuthContext = createContext();
const ONE_HOUR = 3_600_000;              // 1h
const PING_URL = '/auth/me';
const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({
      isAuthenticated: false,
      role: null,
      userId: null,
      name: null,
    });
    const [isLoading, setLoading] = useState(true);
    const [profileCheckPassed, setProfileCheckPassed] = useState(false);
  
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const pingTimerRef = useRef(null); 

    const login = async (form) => {
      const data = await post('/login', form); 
      cacheAuth({ isAuthenticated: true, ...data });
      setIsLoggedIn(true);
      startPing();
    };

    const logout = useCallback(async (expired = false) => {
        stopPing();
        queryClient.clear();

        try {
          await post('/logout');
        } catch (e) {
          console.error(e);
        }

        setIsLoggedIn(false);
        setAuth({ isAuthenticated: false, role: null, userId: null, name: null });
        setProfileCheckPassed(false);

        navigate('/main');

        
        toast.info(expired ? '세션이 만료되었습니다. 다시 로그인해 주세요.' : '로그아웃 되었습니다.');
        
    }, [navigate, queryClient]);

    const cacheAuth = (info) => {
        setAuth(info);
        // sessionStorage.setItem('authInfo', JSON.stringify(info));
      };

    const startPing = useCallback(() => {
        clearInterval(pingTimerRef.current);
        pingTimerRef.current = setInterval(
            () => get(PING_URL).catch(() => logout(true)),
            ONE_HOUR,
        );
    }, [logout]);

    const stopPing = () => clearInterval(pingTimerRef.current);


  

    useEffect(() => setLogoutCallback(logout), [logout]);
  
    useEffect(() => {
        // const cached = sessionStorage.getItem('authInfo');
        // if (cached) {
        //   cacheAuth(JSON.parse(cached));
        //   setIsLoggedIn(true);
        //   startPing();
        //   setLoading(false);
        // } else {
        //   get(PING_URL)
        //     .then((data) => {
        //       cacheAuth({ isAuthenticated: true, ...data });
        //       startPing();
        //     })
        //     .catch(() => setAuth((a) => ({ ...a, isAuthenticated: false })))
        //     .finally(() => setLoading(false));
        // }
      get(PING_URL)
          .then((data) => {
          if (!data.isAuthenticated) return;
          cacheAuth({ isAuthenticated: true, ...data });
          setIsLoggedIn(true); 
          startPing();    
        })
        .catch(() => setAuth((a) => ({ ...a, isAuthenticated: false })))
        .finally(() => setLoading(false));

        return stopPing;
      }, [startPing]);
  

    const passProfileCheck = () => setProfileCheckPassed(true);
  
    return (
      <AuthContext.Provider
        value={{ auth, login, logout, isLoading, profileCheckPassed, passProfileCheck }}
      >
        {children}
      </AuthContext.Provider>
    );
  };
  
  export default AuthProvider;
